export default {
  form: {
    amount: {
      label: 'Preço',
    },
    threshold: {
      label: 'Vendas mensais',
    },
    has_pricing_tiers: {
      label: 'Preço variável com as vendas mensais',
    },
    tax_included: {
      label: 'Imposto incluído',
    },
  },
  buttons: {
    add_tier: 'Adicionar escalão',
  },
};
